// extracted by mini-css-extract-plugin
module.exports = {"box":"style__box__n8NNX","button":"style__button__g0JBS"};